// AUTO-GENERATED GraphQL Builder for HeldShareRebalanceResult
import * as Builders from '../';
export class HeldShareRebalanceResultBuilder {
  private s:string[]=[]; private r:string[]=[]; private v=new Set<string>(); depth=0;
  private add(f:string){ if(!this.s.includes(f)) this.s.push(f); return this; }
  getSelections(){ return [...this.s]; }
  toSelectionSet(){ const a=[...this.s,...this.r]; if(!a.length)return`{ id }`; return`{\n  ${a.join("\n  ")}\n}`;}
  bookingId(){ return this.add('bookingId'); }
  simulated(){ return this.add('simulated'); }
  escrow(){ return this.add('escrow'); }
  rule(){ return this.add('rule'); }

  lines(b?:(q:Builders.HeldShareRebalanceLineBuilder)=>void){
    if(this.depth>=5||this.v.has('lines'))return this;
    this.v.add('lines');
    const n=new Builders.HeldShareRebalanceLineBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`lines { ${inner} }`);
    return this;
  }
}
